<template>
    <a :href="notification.url" class="lc-notification notification">
        <avatar :user="notification.actioned_by" />
        <span class="notification__body">
            <p class="notification__title" v-html="notification.message" />
            <relative-time :timestamp="notification.timestamp" class="notification__meta" />
        </span>
    </a>
</template>

<script>
import RelativeTime from '../Global/RelativeTime'
import Avatar from '../Global/Avatar'

export default {
    name: 'Notifications',

    components: {
        RelativeTime,
        Avatar
    },

    props: {
        notification: {
            required: true,
            type: Object
        }
    }
}
</script>
